import { Subject } from 'rxjs';

export enum EntityDropdownActionType {
    search
}

export enum EntityDropdownEventType {
    valueChange
}

export class EntityDropdownConfig {
    actions$: Subject<{ type: EntityDropdownActionType, payload: any }>;
    events$: Subject<{ type: EntityDropdownEventType, payload: any }>;
    constructor() {
        this.events$ = new Subject();
        this.actions$ = new Subject();
    }
}

